import { Tooltip, Button } from "antd";
import { columnSearchProps } from "components/Table/SearchFilter";
import {
  METHOD_DAY_RANGE_EXCLUSIVE_END,
  strapiFilterProps,
} from "components/Table/StrapiFilter";
import { toLocaleString } from "utils/time";

const renderVersion = (version) => (
  <Tooltip title={version?.description}>{version?.version_name}</Tooltip>
);

export const getVarSeqUploadTableColumns = ({ handleFileClick }) => [
  {
    title: "Form Submitted By",
    dataIndex: "form_submitted_by",
  },
  {
    title: "Batch Sentinel File",
    key: "action",
    render: (_, record) => (
      <Button type="link" onClick={() => handleFileClick(record)}>
        {record?.file_name}
      </Button>
    ),
  },
  {
    title: "Batch Name",
    width: 110,
    dataIndex: "batch_name",
    ...columnSearchProps({ placeholder: "Search by Batch Name" }),
  },
  {
    title: "Seq Ran By",
    dataIndex: "seq_ran_by",
    ...columnSearchProps({ placeholder: "Search by Name or Initials" }),
  },
  {
    title: "Date of Seq",
    width: 120,
    dataIndex: "date_of_seq",
    defaultSortOrder: "descend",
    sorter: true,
    ...strapiFilterProps({
      enabledFilterMethods: [METHOD_DAY_RANGE_EXCLUSIVE_END],
    }),
  },
  {
    title: "Notes",
    width: 280,
    dataIndex: "notes",
    ...columnSearchProps({ placeholder: "Search by Notes" }),
  },
  {
    title: "Protocol Version",
    dataIndex: "lab_protocol_version",
    render: renderVersion,
  },
  {
    title: "Upload Schema Version",
    dataIndex: "upload_schema_version",
    render: renderVersion,
  },
  {
    title: "File Upload Timestamp",
    dataIndex: "created_at",
    sorter: true,
    render: (record) => (record ? toLocaleString(record) : ""),
    ...strapiFilterProps({
      enabledFilterMethods: [METHOD_DAY_RANGE_EXCLUSIVE_END],
    }),
  },
];
